var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPetsshopDog = function SvgPetsshopDog(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 95,
    fill: "none",
    viewBox: "0 0 90 95",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.877,
    cy: 44.877,
    r: 44.877,
    fill: "#FF5100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M57.498 94.5c4.021-.004 15.788-6.468 19.052-8.812a19.2 19.2 0 0 0 6.99-9.457c-4.396-7.141-8.807-15.472-8.807-20.09 4.233.273 5.592-5.769 3.18-9.272 0 0-4.098-5.836-8.425-12.167-2.87-4.194-6.7-6.138-9.935-6.777a4.8 4.8 0 0 0-2.055.052c-3.827-2.944-8.834-4.364-16.384-4.364-7.368 0-11.922 4.13-14.005 10.192a4.47 4.47 0 0 1-3.652 3.011l-8.425 1.333c-2.126.333-4.458 1.698-3.902 3.896 1.025 4.05 2.746 12.802 9.637 13.667 4.681.591 4.951.754 8.615 1.361 4.614.762 8.962 3.9 9.47 8.538.545 4.959.203 16.892-.055 23.68zM35.252 36.713a2.54 2.54 0 0 1-2.343-1.562 2.528 2.528 0 0 1 1.848-3.452 2.54 2.54 0 0 1 2.603 1.077 2.529 2.529 0 0 1-2.108 3.937"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPetsshopDog);
export default ForwardRef;